import Tutorial from '@/components/views/Tutorial';
import steps from "@/router/tutorial-steps.routes";
import store from "@/store";

export default [
	{
		path: '/tutorial',
		component: Tutorial,
		async beforeEnter(to, from, next) {
			await store.dispatch("tutorial/start");
			next();
		},
		children: [
			...steps,
			{
				path: 'start',
				beforeEnter(to, from, next) {
					store.dispatch("global/analytics/trackPageView", { dp: "tutorial" });
					next({ path: "/tutorial/step/0" });
				},
			},
			{
				path: 'complete',
				async beforeEnter(to, from, next) {
					await store.dispatch("tutorial/complete");
					next({ path: "/game/start" });
				},
			},
		],
	},
];



// WEBPACK FOOTER //
// ./src/router/tutorial.routes.js